angular.module('ib-onrequest-flexibilization-module', []);